import { render, staticRenderFns } from "./NoDossiers.vue?vue&type=template&id=203eddba"
import script from "./NoDossiers.vue?vue&type=script&lang=ts"
export * from "./NoDossiers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203eddba')) {
      api.createRecord('203eddba', component.options)
    } else {
      api.reload('203eddba', component.options)
    }
    module.hot.accept("./NoDossiers.vue?vue&type=template&id=203eddba", function () {
      api.rerender('203eddba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NoDossiers.vue"
export default component.exports